var _defs, _circle, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuiviTva2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#D\xE9grad\xE9_sans_nom_25);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#D\xE9grad\xE9_sans_nom_30);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_25",
    "data-name": "D\\xE9grad\\xE9 sans nom 25",
    x1: 870.11,
    y1: 124.62,
    x2: 870.11,
    y2: 1514.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66baed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4478e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    "data-name": "D\\xE9grad\\xE9 sans nom 30",
    x1: 281.59,
    y1: 1339.89,
    x2: 281.59,
    y2: 818.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09d49"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 870.11,
    cy: 800,
    r: 709
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "690.1 1170.55 542.09 1170.55 1050.13 435.06 1198.14 435.06 690.1 1170.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1177.59,722.8c-118.96,0-215.4,88.29-215.4,222.01s96.44,226.03,215.4,226.03,215.4-92.32,215.4-226.03-96.44-222.01-215.4-222.01Zm0,323.45c-37.24,0-67.43-40.97-67.43-100.33s30.19-98.55,67.43-98.55,67.43,39.19,67.43,98.55-30.19,100.33-67.43,100.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m562.64,434.77c-118.96,0-215.4,88.29-215.4,222.01s96.44,226.03,215.4,226.03,215.4-92.32,215.4-226.03-96.44-222.01-215.4-222.01Zm0,323.45c-37.24,0-67.43-40.97-67.43-100.33s30.19-98.55,67.43-98.55,67.43,39.19,67.43,98.55-30.19,100.33-67.43,100.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 281.59,
    cy: 1079.19,
    r: 260.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m299.85,936.39v28.19c11.31,1.82,20.56,5.56,27.76,11.22,7.19,5.66,14.04,14.33,20.56,26.03l-28.04,15.68c-8.44-15.34-19.46-23.01-33.08-23.01-8.44,0-15.44,2.49-21,7.48-5.56,4.99-8.34,11.22-8.34,18.7,0,6.81,2.25,12.46,6.76,16.97,4.41,4.41,13.32,9.64,26.75,15.68,11.6,5.27,21.19,10.24,28.76,14.88,7.57,4.65,13.28,9.13,17.11,13.45,10.83,11.7,16.25,25.84,16.25,42.42s-4.89,30.68-14.67,43.14c-9.69,12.37-22.63,20.71-38.83,25.02v29.77h-25.17v-28.91c-18.79-3.07-33.13-9.54-43-19.41-9.88-9.87-17.16-25.12-21.86-45.73l31.64-6.62c4.31,14.57,9.59,24.98,15.82,31.21,6.52,5.95,15.19,8.92,26.03,8.92s19.37-3.4,26.46-10.21c7-6.71,10.5-15.39,10.5-26.03,0-9.49-2.93-17.11-8.77-22.87-2.97-2.78-7.36-5.92-13.16-9.42-5.8-3.5-13.21-7.31-22.22-11.43-18.6-8.34-30.83-16.01-36.67-23.01-9.3-10.45-13.95-22.96-13.95-37.53,0-6.9,1.1-13.33,3.31-19.27,2.21-5.94,5.39-11.34,9.56-16.18,4.17-4.84,9.32-9.03,15.46-12.58,6.13-3.55,13.09-6.33,20.85-8.34v-28.19h25.17Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiviTva2);
export default __webpack_public_path__ + "static/media/suivi-tva-2.7304df72bd6fae436fd29965e2a655bc.svg";
export { ForwardRef as ReactComponent };